import { createSlice } from '@reduxjs/toolkit';
import { loadState } from 'common/helpers/localStorage';

const anyRepoLoading = (repoStatus) =>
    Object.values(repoStatus).some((status) => status === 'loading');

export const initialState = {
    branches: loadState('branches.branches') ?? {},
    // Per repo: 'idle' | 'loading' | 'succeeded' | 'failed'. Only `branches` is
    // rehydrated from localStorage, so a reload starts every repo back at 'idle'
    // and a previously failed fetch is retried.
    repoStatus: {},
    repoErrors: {}
};

export const slice = createSlice({
    name: 'branches',
    initialState,
    reducers: {
        fetchBranchesRequested: (state, action) => {
            const { repo } = action.payload;
            state.repoStatus[repo] = 'loading';
            delete state.repoErrors[repo];
        },
        fetchBranchesFailed: (state, action) => {
            const { repo, error } = action.payload;
            state.repoStatus[repo] = 'failed';
            state.repoErrors[repo] = error;
        },
        fetchBranchesSucceeded: (state, action) => {
            const { repo, branches } = action.payload;
            state.repoStatus[repo] = 'succeeded';
            delete state.repoErrors[repo];
            state.branches[repo] = branches;
        },
        resetData: (state) => {
            state.branches = {};
            state.repoStatus = {};
            state.repoErrors = {};
        }
    }
});

// Actions
export const {
    fetchBranchesRequested,
    fetchBranchesFailed,
    fetchBranchesSucceeded,
    resetData
} = slice.actions;

// Selectors
export const selectBranches = (state) => state.branches.branches;
export const selectRepoStatuses = (state) => state.branches.repoStatus;
export const selectRepoErrors = (state) => state.branches.repoErrors;
export const selectIsFetching = (state) => anyRepoLoading(state.branches.repoStatus);
export const selectIsLoaded = (state) =>
    Object.keys(state.branches.branches).length > 0 &&
    !anyRepoLoading(state.branches.repoStatus);

export default slice.reducer;
